<template>
  <div class="page_ blue_">
    <div class="bg_">
      <div class="con_">
        <a-form
          class="ant-advanced-search-form"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          :form="form"
          @submit="handleSearch"
        >
          <a-row :gutter="24">
            <a-col :span="7">
              <a-form-item
                class="form-item-style baoxianstyle"
                :label="$t('sublist.InsuranceCard')"
              >
                <div>{{ formData.estQuery.cardno }}</div>
              </a-form-item>
            </a-col>
            <a-col :span="7" :offset="1">
              <a-form-item
                class="form-item-style"
                :label="$t('sublist.thePatient')"
              >
                <div>{{ formData.estQuery.empName }}</div>
              </a-form-item>
            </a-col>
            <a-col :span="7" :offset="1">
              <a-form-item
                class="form-item-style"
                :label="$t('sublist.contact')"
              >
                <div>{{ formData.estQuery.hpno }}</div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="7">
              <a-form-item
                class="form-item-style baoxianstyle"
                :label="$t('sublist.Languageofvisit')"
              >
                <div>
                  {{ formData.empLanguage == "CN" ? "简体中文" : "English" }}
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="7" :offset="1">
              <a-form-item
                class="form-item-style baoxianstyle"
                :label="$t('sublist.medicalInstitution')"
              >
                <div>{{ formData.queryApp.providerName }}</div>
              </a-form-item>
            </a-col>
            <a-col :span="7" :offset="1">
              <a-form-item
                class="form-item-style"
                :label="$t('sublist.Department')"
              >
                <div>{{ formData.queryApp.department || "-" }}</div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="7">
              <a-form-item
                class="form-item-style"
                :label="$t('sublist.Doctor')"
              >
                <div>{{ formData.queryApp.doctor || "-" }}</div>
              </a-form-item>
            </a-col>
            <a-col :span="7" :offset="1">
              <a-form-item
                class="form-item-style"
                :label="$t('sublist.ExpectedDate')"
              >
                <div>
                  {{ new Date(formData.estQuery.appDate).toLocaleDateString() }}
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="7" :offset="1">
              <a-form-item
                class="form-item-style"
                :label="$t('sublist.ExpectedTime')"
              >
                <div>{{ formData.estQuery.appDate | filterDate(lang) }}</div>
              </a-form-item>
            </a-col>
          </a-row>
          <!-- <a-row :gutter="24">
            <a-col>
              <a-form-item :label="$t('sublist.ExpectedDate')">
                <div>{{new Date(formData.estQuery.appDate).toLocaleDateString()}}</div>
              </a-form-item>
            </a-col>
          </a-row> -->
          <!-- <a-row :gutter="24" class="antTime">
            <a-col>
              <a-form-item :label="$t('sublist.ExpectedTime')">
                <div>{{new Date(formData.estQuery.appDate).toLocaleTimeString()}}</div>
              </a-form-item>
            </a-col> -->
          <!-- </a-row> -->
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item
                class="form-item-style"
                :label="$t('sublist.symptom')"
              >
                <div>{{ symptom ? symptom : "无" }}</div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item
                class="form-item-style"
                :label="$t('sublist.remarks')"
              >
                <div>
                  {{
                    newdetails == "来自中间带在线，客户没写备注"
                      ? "无"
                      : newdetails
                  }}
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" :style="{ textAlign: 'right' }">
              <a-button @click="again" v-if="detype == 'again'">{{
                $t("sublist.again")
              }}</a-button>
              <a-button
                @click="cancelYuyue"
                v-if="detype != 'again' && formData.estQuery.querysts != 'I'"
                >{{ $t("sublist.cancelapply") }}</a-button
              >
              <a-button :style="{ marginLeft: '8px' }" @click="back">{{
                $t("hdetail.back")
              }}</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
export default {
  data() {
    return {
      providerCode: this.$route.query.provider_code,
      language: "",
      lang: "",
      form: this.$form.createForm(this, { name: "advanced_search" }),
      expand: false,
      formData: {
        empLanguage: "CN",
        estQuery: {
          queryno: "",
          cardno: "", //保险卡
          empLanguage: "CN", //语言
          empName: "", //就诊人
          hpno: "", //联系方式
          details: "" //备注
        },
        memberControlNo: "",
        queryApp: {
          providerName: "", //医疗机构
          department: "", //科室
          doctor: "", //医生
          appDate: "" //期待预约日期
        }
      },
      detype: "",
      symptom: "",
      newdetails: ""
    };
  },
  computed: {},
  created() {
    this.detype = this.$route.query.type;
    this.getAppointDetail(this.$route.query.queryno);
  },
  mounted() {
    this.language = this.$i18n.locale;
    this.lang = this.$i18n.locale == "en-us" ? "ENGLISH" : "CHINAESE";
  },
  filters: {
    filterData: val => {
      if (val === "" || val === null || val === undefined) {
        return "--";
      } else {
        return val;
      }
    },
    filterDate: (val, lang) => {
      if (val) {
        let str = new Date(val).toLocaleTimeString();
        if (lang == "ENGLISH") {
          if (str.indexOf("上午") > -1) {
            return (
              "AM" + str.substring(str.indexOf("上午") + 2, str.length - 3)
            );
          }
          if (str.indexOf("下午") > -1) {
            return (
              "PM" + str.substring(str.indexOf("下午") + 2, str.length - 3)
            );
          }
        } else {
          return str.substring(0, str.length - 3);
        }
      }
    }
  },
  updated() {
    console.log("updated");
  },
  methods: {
    getAppointDetail(queryno) {
      api
        .getAppointDetail({ queryno: queryno, language: this.language })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.formData = { ...res.data.data };
            let data = res.data.data;
            if (data.estQuery.details.indexOf("&") > -1) {
              let dateilArr_t = data.estQuery.details.split("&");
              this.symptom = dateilArr_t
                .filter(item => item.indexOf("症状：") > -1)[0]
                .split("：")[1];
              this.newdetails = dateilArr_t
                .filter(item => item.indexOf("备注：") > -1)[0]
                .split("：")[1];
            } else {
              let dateilArr_ = (dateilArr_ = data.estQuery.details.split(
                /[(\r\n)\r\n]+/
              ));
              this.symptom = dateilArr_
                .filter(item => item.indexOf("症状：") > -1)[0]
                .split("：")[1];
              this.newdetails = dateilArr_
                .filter(item => item.indexOf("备注：") > -1)[0]
                .split("：")[1];
            }
            if (
              this.newdetails.indexOf("来自中间带在线，客户没写备注。") > -1
            ) {
              this.newdetails = "-";
            }
          }
        });
    },
    handleSearch(e) {
      e.preventDefault();
      this.form.validateFields((error, values) => {
        console.log("error", error);
        console.log("Received values of form: ", values);
      });
    },
    handleSelectChange(value, index, text) {
      console.log("change", value, index, text);
    },
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    //取消预约
    cancelYuyue() {
      let that = this;
      this.$confirm({
        title: this.$t("sublist.tipmsg"),
        content: this.$t("sublist.tipContent"),
        okText: this.$t("sublist.oktext"),
        okType: "danger",
        cancelText: this.$t("sublist.canceltext"),
        onOk() {
          console.log("OK");
          // 取消预约
          api.CancelAppoint(that.formData.estQuery.queryno).then(res => {
            console.log(res);
            if (res.data.code == 200) {
              let message =
                this.$i18n.locale == "en-us"
                  ? "Successfully canceled the appointment！"
                  : "取消预约成功！";
              that.$message.success(message);
              that.$router.push({
                name: "SubscribeLists"
              });
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    },
    /**
     * @name 再次预约
     */
    again() {
      console.log(this.formData);
      this.$router.push({
        name: `Subscribe`,
        query: {
          queryno: this.formData.estQuery.queryno,
          memberNo: this.formData.memberControlNo,
          again: "again"
        }
      });
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.page_ {
  width: 100%;
  .bg_ {
    background-color: #fff;
    border-radius: 10px;
    padding-bottom: 10px;
    > .tit_ {
      padding: 15px 30px;
      border: 1px solid #f3f3f3;
      font-size: 16px;
      color: #394155;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    > .con_ {
      padding: 20px 30px 0px;
      .Operation {
        span {
          margin: 0 5px;
        }
      }
    }
  }
}
.blue_ {
  color: #2c5acc;
  font-weight: bold;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
  margin-bottom: 25px;
  align-items: flex-start;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

.user {
  .ant-select,
  .ant-calendar-picker,
  .ant-time-picker,
  .ant-cascader-picker {
    pointer-events: none !important;
    width: 175px;
  }

  #myCal {
    pointer-events: none !important;
  }

  input,
  textarea {
    pointer-events: none !important;
  }
}
</style>
<style scoped>
.ant-advanced-search-form .form-item-style >>> .ant-form-item-label {
  min-width: 80px !important;
  text-align: left;
  line-height: 20px;
}
.ant-advanced-search-form .form-item-style >>> .ant-form-item-control {
  line-height: 20px;
}
</style>
